export { default as ComplementaryArea } from './complementary-area';
export { default as PinnedItems } from './pinned-items';
